import { render, staticRenderFns } from "./SGAddress.vue?vue&type=template&id=32aa0cfe&"
import script from "./SGAddress.vue?vue&type=script&lang=js&"
export * from "./SGAddress.vue?vue&type=script&lang=js&"
import style0 from "./SGAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SGAddress.vue"
export default component.exports